// icd-thread-rules.js
// 1) Hide unsafe thread colors for the selected hat Color.
// 2) Update YOUR ICD-10 preview when Color or thread changes.

document.addEventListener('DOMContentLoaded', function () {
  // Global combo rules: hat Color (lowercase) -> [thread colors (lowercase) to HIDE]
  var blockedCombos = {
    // Baby Pink hat – white & gold thread are illegible
    "baby pink": ["white", "gold"],

    // Heather Grey hat
    "heather grey": ["flamingo", "kelly", "grey", "orange"],

    // Dark Heather Grey hat
    "dark heather grey": ["flamingo", "kelly", "orange"],

    // Dark-ish hats where navy/black thread gets muddy
    "black": ["navy"],              // keep black-on-black
    "brown": ["navy", "black"],
    "navy": ["navy", "black"],
    "olive": ["navy", "black"],
    "royal": ["navy", "black"],

    // Mixed heathers
    "royal / heather grey": ["grey", "orange"],
    "dark heather grey / red": ["orange"],

    // Red & Neon Pink – orange thread too close
    "red": ["orange"],
    "neon pink": ["orange"]
    // Note: we intentionally keep white-on-white
  };

  var currentHatColor = null;
  var currentThreadColor = null;

  function readHatColorFromDOM() {
    var checked = document.querySelector(
      '.product-form__input input[type="radio"][name*="Color"]:checked'
    );
    if (!checked) return null;
    return (checked.value || "").trim();
  }

  function setActiveThreadButton(button) {
    var active = document.querySelectorAll('.thread-bar__swatch.is-active');
    for (var i = 0; i < active.length; i++) {
      active[i].classList.remove('is-active');
    }
    button.classList.add('is-active');
  }

  function ensureThreadSelection() {
    var items = document.querySelectorAll('.thread-bar__item');
    var chosen = null;

    // Prefer visible Black
    for (var i = 0; i < items.length; i++) {
      if (items[i].style.display === 'none') continue;
      var textEl = items[i].querySelector('.thread-bar__text');
      if (!textEl) continue;
      var name = textEl.textContent.trim().toLowerCase();
      if (name === 'black') {
        chosen = items[i];
        break;
      }
    }
    // Else first visible
    if (!chosen) {
      for (var j = 0; j < items.length; j++) {
        if (items[j].style.display === 'none') continue;
        chosen = items[j];
        break;
      }
    }
    if (chosen) {
      var btn = chosen.querySelector('.thread-bar__swatch');
      if (btn) {
        setActiveThreadButton(btn);
        var label = btn.querySelector('.thread-bar__text');
        currentThreadColor = label ? label.textContent.trim() : null;
      }
    }
  }

  function applyThreadRules() {
    var key = currentHatColor ? currentHatColor.toLowerCase() : "";
    var blocked = blockedCombos[key] || [];

    var items = document.querySelectorAll('.thread-bar__item');
    var firstVisible = null;

    for (var i = 0; i < items.length; i++) {
      var label = items[i].querySelector('.thread-bar__text');
      if (!label) continue;
      var threadName = label.textContent.trim().toLowerCase();
      var hide = blocked.indexOf(threadName) !== -1;
      items[i].style.display = hide ? 'none' : '';
      if (!hide && !firstVisible) {
        firstVisible = items[i];
      }
    }

    // If current thread is now hidden or missing, pick a new one
    var active = document.querySelector('.thread-bar__swatch.is-active');
    if (
      !active ||
      !active.closest ||
      active.closest('.thread-bar__item').style.display === 'none'
    ) {
      ensureThreadSelection();
    } else {
      var label = active.querySelector('.thread-bar__text');
      currentThreadColor = label ? label.textContent.trim() : currentThreadColor;
    }
  }

  function updatePreviewHat() {
    if (!currentHatColor) return;

    var container = document.querySelector('.diagnosis-preview__hat');
    if (!container) return;

    var dataContainer = container.querySelector('.diagnosis-preview__hat-data');
    if (!dataContainer) return;

    var dataDivs = dataContainer.querySelectorAll('[data-hat-color][data-thread]');
    if (!dataDivs.length) return;

    var hatKey = currentHatColor.toLowerCase();
    var threadKey = (currentThreadColor || 'Black').toLowerCase();
    var src = null;

    // Exact hat+thread match (for future multi-thread palettes)
    for (var i = 0; i < dataDivs.length; i++) {
      var hc = (dataDivs[i].getAttribute('data-hat-color') || '').trim().toLowerCase();
      var tc = (dataDivs[i].getAttribute('data-thread') || '').trim().toLowerCase();
      if (hc === hatKey && tc === threadKey) {
        src = dataDivs[i].getAttribute('data-src');
        break;
      }
    }

    // Fallback: hat + black thread
    if (!src) {
      for (var j = 0; j < dataDivs.length; j++) {
        var hc2 = (dataDivs[j].getAttribute('data-hat-color') || '').trim().toLowerCase();
        var tc2 = (dataDivs[j].getAttribute('data-thread') || '').trim().toLowerCase();
        if (hc2 === hatKey && tc2 === 'black') {
          src = dataDivs[j].getAttribute('data-src');
          break;
        }
      }
    }

    // Final fallback: first preview
    if (!src && dataDivs[0]) {
      src = dataDivs[0].getAttribute('data-src');
    }
    if (!src) return;

    var img = container.querySelector('.diagnosis-preview__hat-img');
    var placeholder = container.querySelector('.diagnosis-preview__hat-placeholder');

    if (img) {
      if (img.src !== src) {
        img.src = src;
      }
    } else if (placeholder) {
      var newImg = document.createElement('img');
      newImg.className = 'diagnosis-preview__hat-img';
      newImg.alt = 'YOUR ICD-10 preview beanie';
      newImg.loading = 'lazy';
      newImg.src = src;
      placeholder.parentNode.replaceChild(newImg, placeholder);
    }
  }

  // Initialize current hat color and thread, then apply rules
  currentHatColor = readHatColorFromDOM();
  applyThreadRules();
  if (!currentThreadColor) {
    ensureThreadSelection();
  }
  updatePreviewHat();

  // Listen for Color changes (radio change)
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target.matches('.product-form__input input[type="radio"][name*="Color"]')) {
      currentHatColor = readHatColorFromDOM();
      applyThreadRules();
      updatePreviewHat();
    }
  });

  // Listen for thread dot clicks
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.thread-bar__swatch');
    if (!btn) return;
    var item = btn.closest('.thread-bar__item');
    if (item && item.style.display === 'none') return;

    setActiveThreadButton(btn);
    var label = btn.querySelector('.thread-bar__text');
    currentThreadColor = label ? label.textContent.trim() : currentThreadColor;
    updatePreviewHat();
  });
});